import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";

const SearchIcon = ({ size = "small" }: { size?: "small" | "large" }) => {
  const iconSize = size === "large" ? 24 : 16;

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color: "#6B7280" }}
    >
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  );
};

const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ color: "#6B7280" }}
  >
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </svg>
);

export const SearchHistory = ({
  history,
  onClearHistory,
  onClearItem,
  onItemClick,
}: {
  history: string[];
  onClearHistory: () => void;
  onClearItem: (item: string) => void;
  onItemClick: (item: string) => void;
}) => {
  if (history.length === 0) {
    return (
      <Box 
        width="100%" 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center"
        paddingY={12}
        gap={3}
      >
        <SearchIcon size="large" />
        <Text size={4} color="default2" textAlign="center">
          <FormattedMessage id="7X4M54" defaultMessage="Start searching" />
        </Text>
        <Text size={3} color="default2" textAlign="center">
          <FormattedMessage 
            id="rTw8No" 
            defaultMessage="Search for products, orders, customers and more" 
          />
        </Text>
      </Box>
    );
  }

  const handleRemoveItem = (event: React.MouseEvent<HTMLButtonElement>, item: string) => {
    event.stopPropagation();
    onClearItem(item);
  };

  return (
    <Box width="100%">
      <Text size={2} fontWeight="medium" color="default2" paddingLeft={6}>
        <FormattedMessage id="UE9zNR" defaultMessage="Recent Searches" />
      </Text>
      <Box
        display="flex"
        width="100%"
        flexWrap="wrap"
        alignItems="flex-start"
        gap={2}
        marginTop={5}
        marginBottom={5}
      >
        {history.map(item => (
          <Box
            key={item}
            width="100%"
            paddingX={6}
            cursor="pointer"
            display="flex"
            alignItems="center"
            paddingY={1}
            onClick={() => onItemClick(item)}
            backgroundColor={{
              default: "default1",
              hover: "default1Hovered",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              fontSize={3}
              width="100%"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <SearchIcon />
                {item}
              </Box>
              <Box
                as="button"
                display="flex"
                alignItems="center"
                justifyContent="center"
                padding={0}
                margin={0}
                borderWidth={0}
                backgroundColor="transparent"
                color={{
                  default: "default1",
                  hover: "default2",
                }}
                cursor="pointer"
                onClick={(evt: React.MouseEvent<HTMLButtonElement>) => handleRemoveItem(evt, item)}
              >
                <CloseIcon />
              </Box>
            </Box>
          </Box>
        ))}
        <Box
          as="button"
          display="flex"
          alignItems="center"
          gap={1}
          padding={0}
          margin={0}
          marginTop={1}
          paddingLeft={6}
          borderWidth={0}
          width="100%"
          fontSize={3}
          fontWeight="medium"
          cursor="pointer"
          __height="50px"
          onClick={onClearHistory}
          backgroundColor={{
            default: "default1",
            hover: "default1Hovered",
          }}
        >
          <CloseIcon />
          <FormattedMessage id="zfSKyx" defaultMessage="Clear history" />
        </Box>
      </Box>
    </Box>
  );
};
